import '../../../app.css';
import '../../../title/title.css';
import '../../game.css';

const React = require('react');
const { TwitterShareButton, TwitterIcon } = require('react-share');
const styles = require('../../game.style').default;
const assets = require('../../../../assets').default;
const { renderTwitterButton, getGameClearTitle } = require('../../../../core/twitter').default;
const ModalWindow = require('../../../../core/modal').default;
const { sound, soundType } = require('../../../../core/sound').default;
// ============================

export default class gameClearComponent extends React.Component {
    renderContents() {
        const { playerState: { playerName } } = this.props;
        return (
            <div style={styles.modalStyle}>
                <div className="tips-layout">
                    <div className="tips-message">
                        <div className="tips-text">
                            <div>魔女ジラント:</div>
                            <div>おのれ・・・よもやこれほどの力とは。仕方ない、貴様らの魂を味わうのは、次の機会にするとしよう。</div>
                            <div>・・・　・　　・</div>
                        </div>
                        <div className="tips-image-flex">
                            <img src={assets.ModalZilant} className="tips-image" style={{ opacity: 0.5 }} />
                        </div>
                    </div>
                    <div className="tips-message">
                        <div className="tips-image-flex">
                            <img src={assets.ModalMea02} className="tips-image" />
                        </div>
                        <div className="tips-text">
                            <div>王女メア：</div>
                            <div>！　これは・・・魔女の幻影！？　残念ですが魔女の本体は地下へと逃げ去ってしまったようです。しかし、見事に魔女を城内より撃退することが出来ました！</div>
                            <div>{playerName}様！　本当にありがとうございました！</div>
                        </div>
                    </div>
                    <div className="tips-button">
                        <div className="btn-radius-solid" onClick={() => {
                            sound.playSound(soundType.SE_SELECT_SYSTEM, this.props.soundEnable)
                            this.props.handleTitleClick()
                        }}>次へ</div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return <ModalWindow
            isModalOpen={this.props.isModalOpen}
            isCloseOutOfArea={false}
            contents={this.renderContents()}
        />
    }
}